import React, { useState } from "react";
import InputMask from "react-input-mask";
import authService from "../services/authService";

const Login = ({ onNext }) => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [error, setError] = useState("");

  const phoneRegex = /^7(70[0-9]|77[0-9]|76[0-9]|75[0-9]|74[0-9])([0-9]{3})([0-9]{2})([0-9]{2})$/;

  const handleSubmit = async (e) => {
    e.preventDefault();

    const plainNumber = phoneNumber.replace(/\D/g, "");

    if (!phoneRegex.test(plainNumber)) {
      setError("Invalid phone number. Please follow the format: 7 (700) 123 23 01");
      return;
    }

    setError("");

    try {
      await authService.challenge(plainNumber, null);
      onNext(plainNumber);
    } catch (error) {
      setError("Failed to send OTP. Please try again.");
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <div className="card p-4 shadow-sm" style={{ width: "100%", maxWidth: "400px" }}>
        <h2 className="text-center mb-4">Логин</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group mb-3">
            <label htmlFor="phoneInput">Номер телефона</label>
            <InputMask
              mask="7 (999) 999 99 99"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              className="form-control"
              placeholder="7 (700) 123 23 01"
            />
            {error && <div className="text-danger mt-2">{error}</div>}
          </div>
          <button type="submit" className="btn btn-primary w-100">
            Отправить код
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
